// HOVER DETECTOR v1.0

// <==[--------------------------->

// USAGE A: (most simple)

// 1. add `data-hover-detector` attribute to container element.
//
// BEHAVIOR:
// will add `is-hover` and `is-hover-in` classes to container element on CONTAINER hover.

// <==[--------------------------->

// USAGE B: (triggering hover classes on container from child triggers)

// 1. add 'data-hover-detector` attribute to container element.
// 2. add 'data-hover-detector-item` attribute to individual child triggers.
// 3. container can also have `data-hover-detector-item` attribute.
//
// BEHAVIOR:
// will add `is-hover` and `is-hover-in` classes to container element on ITEM hover.
// hover mouse behavior on container will not trigger classes unless container also contains `data-hover-detector-item`

// <==[--------------------------->

import ResizeController from '../../assets/js/controllers/resize';

import Platform from '../../assets/js/constants/platform';

import { classesActiveAndIn, multiAddEventListener, multiRemoveEventListener, multiClassList, validateParamBoolean } from '../../assets/js/helpers';

export default class HoverDetector {

	static selector = '[data-hover-detector]';

	// class variables

	config = {
		isMobileEnabled: false,
		isContainerHover: false
	};

	el = {};

	flags = {};

	selectors = {
		item: 'data-hover-detector-item',
		isMobileEnabled: 'data-hover-detector-mobile'
	};

	states = {
		itemActive: null
	};

	// constructor

	constructor(container) {
		this.el = {
			container,
			items: container.querySelectorAll(`*:not(${this.constructor.selector}) [${this.selectors.item}]`)
		};

		this.config.isContainerHover = !this.el.items.length || validateParamBoolean(this.el.container, this.selectors.item);
		this.config.isMobileEnabled = validateParamBoolean(this.el.container, this.selectors.isMobileEnabled);

		this.initialize();
	}

	// init

	initialize() {
		this.#addEventListeners();
	}

	// event listeners

	#addEventListeners = () => {
		multiAddEventListener(this.el.items, 'mouseenter', this.#onItemOver);
		multiAddEventListener(this.el.items, 'mouseleave', this.#onItemOut);

		if (this.config.isContainerHover) {
			this.el.container.addEventListener('mouseenter', this.#onItemOver);
			this.el.container.addEventListener('mouseleave', this.#onItemOut);
		}
	}

	#removeEventListeners = () => {
		multiRemoveEventListener(this.el.items, 'mouseenter', this.#onItemOver);
		multiRemoveEventListener(this.el.items, 'mouseleave', this.#onItemOut);

		this.el.container.removeEventListener('mouseenter', this.#onItemOver);
		this.el.container.removeEventListener('mouseleave', this.#onItemOut);
	}

	// listener methods

	#onItemOver = (e) => {
		if (this.states.itemActive) {
			this.states.itemActive.classList.remove('is-hover');
		}

		if (this.config.isMobileEnabled || ResizeController.platform !== Platform.MOBILE) {
			this.states.itemActive = e.currentTarget;

			// remove hover classes on other elements in this container
			multiClassList(this.el.items, 'remove', ['is-hover', 'is-hover-in']);

			classesActiveAndIn(this.states.itemActive, 'is-hover', 'is-hover-in');
			classesActiveAndIn(this.el.container, 'is-hover', 'is-hover-in');
		}
	}

	#onItemOut = () => {
		if (this.states.itemActive) {
			this.states.itemActive.classList.remove('is-hover', 'is-hover-in');
			this.states.itemActive = null;
		}

		this.el.container.classList.remove('is-hover', 'is-hover-in');
	}

	// destroy

	destroy() {
		this.#removeEventListeners();
	}

}
